import { useHistory } from 'react-router-dom';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import React  from 'react';
import './style.sass';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'

export default function SolicitarPermisosMobile() {
    const history = useHistory();

    // presiona continuar, redirige a solicitud exitosa
    const handleSolicitar = () => {
        history.push("/solicitud-exitosa");
    };

    // cancela la solicitud
    const handleBack = () => {
        history.goBack(-1);
    };

    return (
        <>
            <div className="modalCredito full">
                <div className="contentModal">
                    <HeaderMobileCredito title="Estado de cuenta" type="back" />

                    <div className="contenedorGeneral">
                        <div className="boxPermisos">
                            <div className="boxIconoPermisos">
                                <img src={`${BASE_PATH}${SUB_DIRECTORY}/save.png`} alt="logo-digital"></img>
                            </div>

                            <div className="boxContenidoPermisos">

                                <div className="bx1">
                                    <h4>Cuidemos el medio ambiente</h4>
                                    <p>Olvídate del papel y recibe tu estado de cuenta vía correo electrónico.</p>
                                </div>

                                <div className="bx2">
                                    <label className="checkboxContent fileset">
                                        <input type="checkbox" name="condiciones" id="condiciones" />
                                        <p>He leído y estoy de acuerdo con los <span className="bold">Términos y condiciones</span> de uso del servicio.</p>
                                    </label>
                                </div>

                            </div>

                            <div className="boxBotones">
                                <button className="btnSolicitar" onClick={handleSolicitar}>Solicitar</button>
                                <button className="btnCancelar" onClick={handleBack}>Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}